import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import * as BSL_Common from "../../components/BSL_CommonControls";
import BSL_Button from "../../components/BSL_Button";
import BSL_Dialog from "../../components/BSL_Dialog";
import * as APP from "../../redux_store/appState";
import { ClearScratch } from "../layout/PaperDesigner";
import {
    updateAreaSpecification,
    updateAreaSpecificationModificationArray,
    deleteFromAreaSpecificationModificationArray,
} from "../../redux_store/jobState";

import BSL_UploadDocument from "../../components/BSL_Upload/BSL_UploadDocument";
import Message from "../../components/Message";

const useStyles = makeStyles({
    root: {},
});

export default function SpecAdjustLabels(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { edit_note, areaIndex } = props;
    const app = useSelector((state) => state.app);
    const AREA_INDEX = app.designer.designer2D?.[APP.AREA_INDEX];
    const job = useSelector((state) => state.job);
    const SELECTED_POINTS = app.designer.designer2D[APP.SELECTED_POINT];

    const SELECT_POINT = app.designer.designer2D[APP.SELECT_POINT];
    const [showNoteDialog, setShowNoteDialog] = React.useState(edit_note ? true : false);
    const [waitingForPoints, setWaitingForPoints] = React.useState(false);
    const [loaded, setLoaded] = React.useState(false);

    const [showMessage, setShowMessage] = React.useState(false);
    const [imageName, setImageName] = React.useState(edit_note?.Image ? edit_note.Image : "none");

    let edit_note_text = "";
    if (edit_note)
        for (let i = 1; i < 10; i++) {
            let text = edit_note["Note" + (i > 1 ? i : "")];
            if (text != undefined && text != null) edit_note_text += (edit_note_text === "" ? "" : "\n") + text;
        }

    const [inputValue, setInputValue] = React.useState(edit_note_text.replace("📷 ", ""));
    // const [password, setPassword] = React.useState("");
    // const rows = useSelector(state => state.app.user_last_jobs_edited);

    React.useEffect(() => {
        if (!loaded) return;
        if (SELECTED_POINTS && waitingForPoints) {
            // setWaitingForPoints(false);
            // dispatch(APP.update2DDesigner(APP.SELECT_POINT, 0));
            // setInputValue("");
            // setShowNoteDialog(true);
            dispatch(updateAreaSpecification(0, "LabelAdjustments", null, SELECTED_POINTS));
            APP.update2DDesigner(APP.SELECT_POINT, false);
        }
    }, [SELECTED_POINTS]);

    React.useEffect(() => {
        // if (AREA_INDEX !== areaIndex && job.AreaSpecifications.length > 1) return;
        // else if (AREA_INDEX !== areaIndex) return;
        if (!loaded) return;
        if (SELECT_POINT === false && !edit_note) {
            setWaitingForPoints(false);
            dispatch(APP.updateDesigner(APP.TOOL_DRAWER_HIDE, false));
            if (job.AreaSpecifications.length > 1) {
                // dispatch(APP.setDesignerLoadingBackdrop("Reloading Full Layout..."));
                // dispatch(APP.update2DDesigner(APP.AREA_INDEX, -1));
            }
        }
    }, [SELECT_POINT]);

    const moveLabels = () => {
        setWaitingForPoints(true);
        ClearScratch();
        // if (job.AreaSpecifications.length > 1) {
        //     dispatch(APP.update2DDesigner(APP.AREA_INDEX, areaIndex));
        //     dispatch(APP.setDesignerLoadingBackdrop("Loading Area " + (areaIndex + 1) + " Layout..."));
        // }
        dispatch(APP.update2DDesigner(APP.SELECT_POINT_NOTE, <>*Right click or press 'ESC' to finish.</>));
        dispatch(APP.updateDesigner(APP.TOOL_DRAWER_HIDE, true));
        dispatch(APP.update2DDesigner(APP.SELECT_POINT, "MoveLabels"));
        // dispatch(APP.update2DDesigner(APP.SELECT_POINT_ALLOW_HIT_SELTYPE, "note"));

        // dispatch(update2DDesigner(APP.SELECTED_POINT, {x: 0, y: 0}));
    };

    const wipeLabelAdjustments = () => {
        dispatch(updateAreaSpecification(0, "LabelAdjustments", null, []));
    };

    const onClose = () => {
        ClearScratch();
        setInputValue("");
        setShowNoteDialog(false);

        if (props.onClose) {
            props.onClose();
            return;
        }

        setWaitingForPoints(true);
        dispatch(APP.update2DDesigner(APP.SELECT_POINT, "2 Arrow"));
    };

    if (!loaded) setLoaded(true);

    return (
        <>
            <BSL_Common.SectionRow>
                <BSL_Button
                    style={{ marginLeft: "8px", alignSelf: "center", width: "60%" }}
                    onClick={moveLabels}
                    disabled={app.designer.threeDMode && !app.designer.threeDMiniMode}
                    disabledTooltip="Cannot adjsut labels in 3D Model View"
                >
                    Adjust Labels {app.designer.threeDMode && !app.designer.threeDMiniMode ? "(Plan View Only)" : ""}
                </BSL_Button>
                <BSL_Button
                    secondary
                    style={{ marginLeft: "8px", alignSelf: "center", flex: 1 }}
                    onClick={wipeLabelAdjustments}
                >
                    Reset All Labels
                </BSL_Button>
            </BSL_Common.SectionRow>
        </>
    );
}

// NumNewBeams=1
// _1_P1=(1136.00,1807.50,0.00)
// _1_P2=(1638.00,32.50,0.00)
// _1_Section=1586510
// _1_Offset1=1136
// _1_Offset2=1638
// _1_From1Side1=0
// _1_From1Side2=1
